export type BillingActivityTone = 'success' | 'warning' | 'danger' | 'neutral';

export interface BillingActivityPresentation {
  label: string;
  tone: BillingActivityTone;
}

const titleCase = (value: string) =>
  value
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (character) => character.toUpperCase());

export const getBillingActivityPresentation = (
  status?: string,
): BillingActivityPresentation => {
  const normalizedStatus = status?.trim().toLowerCase() || '';

  if (normalizedStatus === 'active' || normalizedStatus === 'completed') {
    return {
      label: normalizedStatus === 'active' ? 'Active' : 'Completed',
      tone: 'success',
    };
  }

  if (normalizedStatus === 'pending') {
    return {
      label: 'Payment required',
      tone: 'warning',
    };
  }

  if (
    normalizedStatus === 'failed' ||
    normalizedStatus === 'past_due' ||
    normalizedStatus === 'unpaid'
  ) {
    return {
      label: 'Payment failed',
      tone: 'danger',
    };
  }

  if (normalizedStatus === 'canceled' || normalizedStatus === 'cancelled') {
    return {
      label: 'Cancelled',
      tone: 'neutral',
    };
  }

  return {
    label: normalizedStatus
      ? titleCase(normalizedStatus)
      : 'Status unavailable',
    tone: 'neutral',
  };
};
